import { Component ,Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';

@Component({
  selector: 'app-leeds-beckett',
  templateUrl: './leeds-beckett.component.html',
  styleUrls: ['./leeds-beckett.component.scss']
})
export class LeedsBeckettComponent {
  fullName: string;
  email: any;
  date: any;
  emailComponent= '@'
  
  constructor(
      public dialog: MatDialog,
      public dialogRef: MatDialogRef<LeedsBeckettComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }
    ngOnInit(): void {
      if(this.data){
        this.fullName = `${this.data.firstName} ${this.data.lastName}`.toUpperCase();
        this.email = this.data.email;
        this.date = this.data.date;
      }
    }
    close(val?: any) {
      this.dialogRef.close(val);
    }
    sendForSignature() {
      this.dialogRef.close('sendForSignature');
  }
}
